import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { EXPRESS_API } from 'configs/api/expressApi';
import { organizationVideoQueryKeys } from './queryKeys';

interface IDuplicatePlaylistPayload {
  year: number;
  playlist: string;
  selectedOrganizationVideoIds: number[];
}

const duplicatePlaylist = async (payload: IDuplicatePlaylistPayload) => {
  return await EXPRESS_API.post(
    `/organization-videos/duplicate/playlist`,
    payload
  );
};

interface IUseDuplicatePlaylistMutation {
  onSuccessCallback?: () => void;
}

export const useDuplicateOrganizationVideoPlaylistMutation = ({
  onSuccessCallback,
}: IUseDuplicatePlaylistMutation = {}) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();

  return useMutation(duplicatePlaylist, {
    onSuccess: () => {
      queryClient.invalidateQueries(organizationVideoQueryKeys.all);
      successToast({ title: 'Playlist has been duplicated!' });
      onSuccessCallback?.();
    },
    onError: error =>
      showError(
        error,
        'An error occurred while trying to duplicate the playlist!'
      ),
  });
};
